import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar/Index";
import { Link, useParams } from "react-router-dom";
import ExpenseTable from "./expenseTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleLeft,
  faMoneyBill,
  faClockRotateLeft,
  faListCheck,
  faMoneyBillTrendUp,
} from "@fortawesome/free-solid-svg-icons";
import ExpensesModal from "../../components/Modal";
import AddMemberModal from "../../components/Groups/AddMember";

import SummaryTable from "./summaryTable";
import SettleHistory from "./settleHistoryTable";
function Table() {
  const [loading, setLoading] = useState(false);
  const [expenses, setExpenses] = useState([]);
  const [summary, setSummary] = useState([]);
  const [total, setTotal] = useState(0);
  const [youPaid, setYouPaid] = useState(0);
  const [yourShare, setYourShare] = useState(0);
  const [error, setError] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const { id } = useParams();
  const [isOpen, setIsOpen] = useState(false);
  const [isAddMemberOpen, setIsAddMemberOpen] = useState(false);

  const [activeTab, setActiveTab] = useState("expenses");
  const [data, setData] = useState([]);
  const [settleHistory, setSettleHistory] = useState([]);
  const [reload, setReload] = useState(false);

  const [showOptions, setShowOptions] = useState(false);

  const handleHover = () => {
    setShowOptions(!showOptions);
  };

 
  const addMemberOnClick = () => {
    setIsAddMemberOpen(true);
  };

  const closeMemberModal = () => {
    setIsAddMemberOpen(false);
  };
  const addExpenseOnClick = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setReload(!reload);
  };
  useEffect(() => {
    const fetchData = async () => {

      setLoading(true);
      try {
        const url = `https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/expenses/getGroupSummary/${id}`;
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.idToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const responseData = await response.json();
        setSummary(responseData);
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [reload]);

  useEffect(() => {
    const fetchData = async () => {

      setLoading(true);
      try {
        const url = `https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/expenses/getAllExpenses/${id}`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.idToken}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const responseData = await response.json();
        setExpenses(
          responseData.sort((a, b) => new Date(b.date) - new Date(a.date))
        );
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, user.idToken, reload]); // Added id and user.idToken as dependencies

  useEffect(() => {

    let totalAmount = 0;
    let youPaidAmount = 0;
    let yourShareAmount = 0;

    expenses.forEach((item) => {
      const expense =
        item.paidBy === user.email
          ? item.totalAmount -
              item.participants.find((row) => row.userId === user.email)
                ?.share || 0
          : -item.participants.find((row) => row.userId === user.email)
              ?.share || 0;

      if(!item.isSettle){
        totalAmount += item.totalAmount;
      }        
      if (item.paidBy === user.email) {
        youPaidAmount += item.totalAmount;
      }
      yourShareAmount +=
        item.participants.find((row) => row.userId === user.email)?.share || 0;
    });

    setTotal(totalAmount);
    setYouPaid(youPaidAmount);
    setYourShare(yourShareAmount);
  }, [expenses, user.email, reload]);

  const dataHeader = [
    {
      key: "date",
      label: "Date",
    },
    {
      key: "description",
      label: "Description",
    },
    {
      key: "lent",
      label: "Lent",
    },
    {
      key: "action",
      label: "Action",
    },
  ];

  const handleDelete = () => {};

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const options = { month: "long", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  useEffect(() => {

    // Filter expenses for data
    const newData = expenses
      .filter((item) => !item.isSettle)
      .map((item, id) => ({
        id,
        date: formatDate(item.date),
        description: item.description,
        expense:
          item.paidBy === user.email
            ? item.totalAmount -
              (item.participants.find((row) => row.userId === user.email)
                ?.share || 0)
            : -(
                item.participants.find((row) => row.userId === user.email)
                  ?.share || 0
              ),
        data: item,
      }));

    // Filter expenses for settleHistory
    const newSettleHistory = expenses
      .filter((item) => item.isSettle)
      .map((item, id) => ({
        id,
        date: formatDate(item.date),
        description: item.description,
        data: item,
      }));

    setData(newData);
    setSettleHistory(newSettleHistory);
  }, [expenses, user.email, reload]);
  const color = "bg-green-600";
  return (
    <>
      <main className="h-full">
        <Navbar />

        {/* Main Content */}
        <div className="mainCard">
          <Link
            to={`/groups`}
            className={`text-green-700 inline-flex py-2 px-2 rounded  text-lg`}
          >
            <FontAwesomeIcon icon={faCircleLeft} />
          </Link>

          <div className="border w-full border-gray-200 bg-white py-4 px-6 rounded-md">
            <div className="grid md:flex md:flex-wrap md:justify-between">
              <div
                className={`widgetCard relative flex-grow px-6 py-10 text-center flex-col justify-between mb-4 md:mb-0 md:mr-4 ${color} text-slate-50`}
              >
                <div className="font-semibold m-auto">
                  <span className="text-lg lg:text-[80px]">₹{total}</span>
                  <span className="text-sm absolute bottom-0 left-0 ml-2 mb-2">
                    Total Group Spending
                  </span>
                </div>
              </div>
              <div
                className={`widgetCard relative flex-grow px-6 py-10 text-center flex-col justify-between mb-4 md:mb-0 md:mr-4 ${color} text-slate-50`}
              >
                <div className="font-semibold m-auto">
                  <span className="text-lg lg:text-[80px]">₹{youPaid}</span>
                  <span className="text-sm absolute bottom-0 left-0 ml-2 mb-2">
                    Total You Paid For
                  </span>
                </div>
              </div>
              <div
                className={`widgetCard relative flex-grow px-6 py-10 text-center flex-col justify-between mb-4 md:mb-0 ${color} text-slate-50`}
              >
                <div className="font-semibold m-auto">
                  <span className="text-lg lg:text-[80px]">₹{yourShare}</span>
                  <span className="text-sm absolute bottom-0 left-0 ml-2 mb-2">
                    Your Total Share
                  </span>
                </div>
              </div>
            </div>
            <div className="flex justify-center m-2">
              <div className="inline-flex rounded-lg border border-gray-100 bg-gray-100 p-1">
                <button
                  className={`inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm focus:outline-none 
          ${
            activeTab === "expenses"
              ? "text-green-500 underline"
              : "text-gray-500 hover:text-gray-700"
          }`}
                  onClick={() => setActiveTab("expenses")}
                >
                  <FontAwesomeIcon icon={faMoneyBillTrendUp} />
                  Expenses
                </button>

                <button
                  className={`inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm focus:outline-none 
          ${
            activeTab === "summary"
              ? "text-green-500 underline"
              : "text-gray-500 hover:text-gray-700"
          }`}
                  onClick={() => setActiveTab("summary")}
                >
                  <FontAwesomeIcon icon={faListCheck} />
                  Summary
                </button>

                <button
                  className={`inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm focus:outline-none 
          ${
            activeTab === "settleHistory"
              ? "text-green-500 underline"
              : "text-gray-500 hover:text-gray-700"
          }`}
                  onClick={() => setActiveTab("settleHistory")}
                >
                  <FontAwesomeIcon icon={faClockRotateLeft} />
                  Settle History
                </button>
              </div>
            </div>
            {activeTab === "expenses" ? (
              <ExpenseTable
                loading={loading}
                dataHeader={dataHeader}
                data={data}
                handleDelete={handleDelete}
                reload={reload}
                setReload={setReload}
              />
            ) : null}
            {activeTab === "summary" ? (
              <SummaryTable
                loading={loading}
                data={summary}
                handleDelete={handleDelete}
                setReload={setReload}
                reload={reload}
              />
            ) : null}

            {activeTab === "settleHistory" ? (
              <SettleHistory
                loading={loading}
                data={settleHistory}
                handleDelete={handleDelete}
              />
            ) : null}
          </div>
        </div>
        <div className="fixed bottom-20 right-8">
              <div className="relative">
            <button className="plus-button rounded-full bg-green-500 text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500" onClick={handleHover} style={{width: "40px", height: "40px"}}>
              +
            </button>
            {showOptions && (
              <div className="absolute flex flex-col items-center justify-center bottom-full left-1/2 transform -translate-x-1/2 mb-2">
                <button className="option-button rounded-2xl bg-green-500 text-white shadow-md p-2 m-2" onClick={() => addExpenseOnClick()}>
                  + Expense
                </button>
                <button className="option-button rounded-2xl bg-green-500 text-white shadow-md p-2 m-2" onClick={() => addMemberOnClick()}>
                + Member
                </button>
              </div>
            )}
          </div>
          {/* <button
            className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded-full shadow-lg relative overflow-hidden transition-all duration-300"
            style={{ zIndex: 999, width: "70px", height: "70px" }}
            onClick={() => addExpenseOnClick()}
            onMouseEnter={() => {
              document
                .getElementById("expense-text")
                .classList.remove("opacity-0");
              document.getElementById("plus-text").classList.add("opacity-0");
            }}
            onMouseLeave={() => {
              document
                .getElementById("expense-text")
                .classList.add("opacity-0");
              document
                .getElementById("plus-text")
                .classList.remove("opacity-0");
            }}
          >
            <span
              id="plus-text"
              className="absolute inset-0 flex justify-center items-center opacity-0 transition-opacity"
            >
              +
            </span>
            <span
              id="expense-text"
              className="absolute inset-0 flex justify-center items-center opacity-0 transition-opacity"
            >
              + Expense
            </span>
          </button> */}
        </div>
        <ExpensesModal
          isOpen={isOpen}
          setModal={setIsOpen}
          onClose={closeModal}
          groupData={{ groupid: id }}
        />
         <AddMemberModal
          isOpen={isAddMemberOpen}
          setModal={setIsAddMemberOpen}
          onClose={closeMemberModal}
          groupData={{ groupid: id }}
        />

      </main>
    </>
  );
}

export default Table;
